import { Injectable } from '@angular/core';


import { ChartsCardReadyState, ChartsCardState } from './chart-card-state';
import { ChartsCardEvent, ChartsCardInitEvent } from './chart-card-event';
import { Bloc, ErrorState, ShowLoadingComponentState } from '../base-bloc';
import { takeUntil } from 'rxjs/operators';
import { Drawing } from '../../model';

@Injectable()
export class ChartsCardBloc extends Bloc<ChartsCardEvent, ChartsCardState> {
  constructor() {
    super();
  }

  onIncomingEvents(event: ChartsCardEvent) {
    if(event instanceof ChartsCardInitEvent){
      this.onState$.next(new ShowLoadingComponentState(true));
      event.caller().pipe(takeUntil(this.destroy$)).subscribe({
        next: (result) => {
          this.onState$.next(new ChartsCardReadyState(result));
        },
        error: (error) => {
          this.onState$.next(new ErrorState<Drawing>(new Drawing(), error));
        },
      })
    }
  }
}
